
import { interfaces } from "inversify";
import { QueuesData } from "../QueueStatsQueuesProvider";
import { ErrorSeverity, ErrorCode, ThrowAndReportErrorFunction, throwAndReportErrorRTTI } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { queueStatsServiceRTTI } from "~/backend/backend.rtti";
import { extractFileNameFromPath, extractModuleFromPath } from "~/utils/extractFromPath";
import { QuequeStatsService } from "~/backend/generated/QueueStats/api/quequeStats.serviceInterface";

const metadata = {
    module: extractModuleFromPath(__dirname),
    eventSource: extractFileNameFromPath(__filename)
};

export const QueueStatsQueuesProviderImpl =
    ({ container }: interfaces.Context) =>
    async (sessionToken: string, workspaceSid: string, queryParams?: string): Promise<QueuesData> => {
        const queueStatsService = container.get<QuequeStatsService>(queueStatsServiceRTTI);
        const throwAndReportError = container.get<ThrowAndReportErrorFunction>(throwAndReportErrorRTTI);
        const logger = getLogger(LoggerName.Config);

        let queuesData: QueuesData;

        try {
            if (queryParams) {
                const queryParamData = new URLSearchParams(queryParams);
                if (queryParamData.get("PageSize") && queryParamData.get("Page")) {
                    queuesData = await queueStatsService.fetchQueuesByPage(
                        workspaceSid,
                        "PageSize",
                        queryParamData.get("PageSize") || "",
                        "Page",
                        queryParamData.get("Page") || "",
                        { token: sessionToken }
                    );
                } else {
                    throw new Error("Invalid query Parameters");
                }
            } else {
                queuesData = await queueStatsService.fetchQueues(workspaceSid, { token: sessionToken });
            }
        } catch (err) {
            logger.warn(`Failed to fetch task queues: ${err}`);

            if (err.message === "Invalid query Parameters") {
                return throwAndReportError(
                    ErrorCode.InvalidParams,
                    { ...metadata, severity: ErrorSeverity.Error },
                    err.message
                );
            }
            const message = `Failed to fetch task queues: ${err}.`;
            const errorCode = err.code || ErrorCode.Unknown;
            return throwAndReportError(errorCode, { ...metadata, severity: ErrorSeverity.Error }, message);
        }
        return queuesData;
    };
